<template>
  <div>
    <div class="items"
         v-infinite-scroll="loadMore"
         infinite-scroll-disabled="busy"
         infinite-scroll-distance="1000"
    >
      <ItemsItem v-for="item in items" v-bind="item" :key="item.id"></ItemsItem>
    </div>
  </div>
</template>

<script>
  import axios from 'axios';
  import ItemsItem from './items/Item';
  export default {
    name: 'Popular',
    components: {ItemsItem},
    data () {
      return {
        busy: false
      };
    },
    created () {
      if (this.items.length > 0) return;  // キャッシュ
      this.fetch();
    },
    computed: {
      items () {
        return this.$store.state.items;
      },
      item_next_page_url () {
        return this.$store.state.item_next_page_url;
      }
    },
    methods: {
      async fetch () {
        if (this.busy) return;
        if (!this.item_next_page_url) return;
        this.busy = true;
        this.$store.commit('setLoading');
        const response = await axios.get(this.item_next_page_url);
        this.$store.commit('addItems', response.data.items.data);
        this.$store.commit('setItemNextPageUrl', response.data.items.next_page_url);
        this.$store.commit('resetLoading');
        this.busy = false;
      },
      loadMore: function () {
        setTimeout(() => {
          this.fetch();
        }, 1000);
      }
    },
  };
</script>

<style scoped lang="scss">
  .items {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }
</style>
